export default __webpack_public_path__ + "static/media/massab.c5463534.png";